import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { consumeVerificationToken } from "../../js/auth/emailVerification";
import { verifyEmailForUser } from "../../js/auth/authOnboarding";
import { resolvePostAuthPath } from "../../js/auth/onboardingState";
import { useAuth } from "../../js/hooks/useAuth";
import { useStore } from "../../js/state/store";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { session } = useAuth();
  const { dispatch } = useStore();
  const [status, setStatus] = useState("working");
  const token = params.get("token") || "";

  useEffect(() => {
    if (!token) {
      setStatus("missing");
      return;
    }
    const match = consumeVerificationToken(token);
    if (!match) {
      setStatus("invalid");
      return;
    }
    const nextSession = verifyEmailForUser(match.userId);
    if (nextSession) dispatch({ type: "SET_SESSION", payload: nextSession });
    setStatus("ok");
    window.setTimeout(() => {
      navigate(resolvePostAuthPath(nextSession || session), { replace: true });
    }, 1200);
  }, [dispatch, navigate, session, token]);

  return (
    <AppLayout>
      <article className="card auth-card onboarding-card">
        {status === "working" ? <h1>Verifying…</h1> : null}
        {status === "ok" ? (
          <>
            <h1>Email verified</h1>
            <p className="confirm">Taking you to the next onboarding step.</p>
          </>
        ) : null}
        {status === "invalid" ? (
          <>
            <h1>Link expired or invalid</h1>
            <p className="page-lead">Request a fresh verification link from your account email page.</p>
            <Link className="primary-btn" to="/verify-email/pending">
              Back to verification
            </Link>
          </>
        ) : null}
        {status === "missing" ? (
          <>
            <h1>No token found</h1>
            <Link className="primary-btn" to="/verify-email/pending">
              Open verification
            </Link>
          </>
        ) : null}
      </article>
    </AppLayout>
  );
}
